import React from 'react';
import Cookies from 'js-cookie';
import Analytics from 'services/utils/Analytics';
import Settings from 'services/config/Settings';
import fetchJSON from 'services/utils/fetchJSON';

class MarketingPromo extends React.Component {
	componentDidMount = () => {
		if (this.props.match.params) {
			const referralCode = this.props.match.params.referralCode ? this.props.match.params.referralCode : false;
			if (referralCode) {
				Analytics('User used Marketing Promo Link', { Promo: referralCode });
				fetchJSON(Settings.endpoindApi+'/api/v1/promo/link', {
					method: 'post',
					body: {
						promocode_key: referralCode
					},
					headers: {
						Source: 'Marketing'
					}
				}).then(data => {
					if (data.code === 200) {
						Analytics('Сorrect Marketing Promo Link', { Promo: referralCode });
						Cookies.set('referral', referralCode, { expires: 365 });
						this.props.history.push("/?m=referral");
					} else {
						this.goToFrontPage();
					}
				})
				.catch(error => {
					console.log(error);
					this.goToFrontPage();
				});
			} else {
				this.goToFrontPage();
			}
		} else {
			this.goToFrontPage();
		}
  }
  goToFrontPage() {
  	Analytics('Marketing Promo Link is invalid');
  	Cookies.remove('referral');
  	this.props.history.push('/');
  }
  render() {
  	return null;
  }
}


export default MarketingPromo;